module.exports = [
  'Consultorios externos',
  'Admisión',
  'Hospital de día',
  'Clínicas y estudios de mayor complejidad',
  'Clínica de dolor',
  'Laboratorio',
  'CIM'
]